import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c6e2449e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6e2449e')) {
      api.createRecord('c6e2449e', component.options)
    } else {
      api.reload('c6e2449e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c6e2449e&", function () {
      api.rerender('c6e2449e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configuration/role/index.vue"
export default component.exports